import React, { useEffect } from 'react';
import Slug from '../../../../../views/components/slug/slug';

const NewsletterPageMarketo = () => {
  const initializeMarketo = () =>
    new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src =
        'https://register.fastcompany.com/js/forms2/js/forms2.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

  useEffect(() => {
    initializeMarketo()
      .then(() => {
        window.MktoForms2.loadForm(
          '//register.fastcompany.com',
          '610-LEE-872',
          1018
        );
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.log('Error initializing Marketo: ', err);
      });
  }, []);

  return (
    <div>
      <Slug slugName="Newsletters" className="category-page" />
      <section className="newsletters__page__marketo">
        <div className="newsletters__page__marketo__form__container">
          <form id="mktoForm_1018" />
        </div>
      </section>
    </div>
  );
};

export default NewsletterPageMarketo;
